import { render } from "./kaijizhanbi.vue?vue&type=template&id=fced9dec&scoped=true"
import script from "./kaijizhanbi.vue?vue&type=script&lang=js"
export * from "./kaijizhanbi.vue?vue&type=script&lang=js"

import "./kaijizhanbi.vue?vue&type=style&index=0&id=fced9dec&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fced9dec"]])

export default __exports__